import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { renderTrustedMarkdown } from '~/functions/markdown';
import { ReportType, useUpdateReportAnswerMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'TextMaster',
  props: {
    id: {
      type: [Number, String],
      required: false,
      default: 0
    },
    value: {
      type: [String, Number, Boolean, Array],
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    tooltip: {
      type: String,
      required: false,
      default: ''
    },
    tooltipTitle: {
      type: String,
      required: false,
      default: ''
    },
    isMandatory: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isCopyable: {
      type: Boolean,
      required: false,
      default: false
    },
    copyableText: {
      type: String,
      required: false,
      default: ''
    },
    copyableOptions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    useComboBox: {
      type: Boolean,
      required: false,
      default: false
    },
    useTextField: {
      type: Boolean,
      required: false,
      default: true
    },
    useTextArea: {
      type: Boolean,
      required: false,
      default: false
    },
    textFieldType: {
      type: String,
      required: false,
      default: 'text'
    },
    useDatePicker: {
      type: Boolean,
      required: false,
      default: false
    },
    useBinary: {
      type: Boolean,
      required: false,
      default: false
    },
    portfolioId: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      // props that directly mapping to our database base Option, which can be linked using questionoptionlink for each question
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    useLargeOptions: {
      type: Boolean,
      required: false,
      default: false
    },
    allowDeselection: {
      type: Boolean,
      required: false,
      default: true
    },
    inputOptions: {
      // TODO consider remove this
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    useSmallOptions: {
      type: Boolean,
      required: false,
      default: false
    },
    items: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    showCopyButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showTranslateButton: {
      type: Boolean,
      required: false,
      default: false
    },
    component: {
      type: String,
      required: false,
      default: ''
    },
    reportType: {
      type: String,
      required: false,
      default: ReportType.SfdrPeriodic
    },
    disclosureSummary: {
      type: String,
      required: false,
      default: ''
    },
    promptTemplate: {
      type: Object,
      required: false
    },
    validator: {
      type: Function,
      required: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var useMultipleOptions = computed(function () {
      return props.value instanceof Array;
    });
    var _useUpdateReportAnswe = useUpdateReportAnswerMutation(),
      updateReportAnswer = _useUpdateReportAnswe.mutate;
    var route = useRoute();
    var attrs = useAttrs();
    var reportKeyMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ReportType.SfdrEntityWebsiteDisclosure, 'entityWebsiteDisclosureData'), ReportType.SfdrFundWebsiteDisclosure, 'fundWebsiteDisclosureData'), ReportType.SfdrPai, 'paiReportData'), ReportType.SfdrPeriodic, 'periodicReportData'), ReportType.SfdrPrecontractual, 'precontractualReportData');
    var onInput = function onInput(val) {
      valueRef.value = val;
      var key = String(attrs.ixId);
      console.log('On Input TextMaster');
      console.log('key', key);
      console.log('val', val);
      if (key && ['QuestionType', 'QuestionSectionLinkType'].includes(attrs.__typename)) {
        var input = {
          fundId: toNumber(route.params.fund),
          referencePeriodId: toNumber(route.query.referencePeriodId),
          reportType: props.reportType,
          periodicReportData: {},
          paiReportData: {},
          fundWebsiteDisclosureData: {},
          entityWebsiteDisclosureData: {},
          precontractualReportData: {}
        };
        var dataKey = reportKeyMap[props.reportType];
        input[dataKey] = _defineProperty({}, key, val === undefined || val === '' ? null : val);
        updateReportAnswer({
          input: input
        });
      }
    };
    var expanded = ref(true);
    var valueRef = ref(props.value); // We need to this to update UI when user clicks "COPY", FIXME: but this should be improved by change the props from the top.
    watch(function () {
      return props.value;
    }, function () {
      valueRef.value = props.value;
    });
    var validationResult = computed(function () {
      if (!props.validator || !valueRef.value) {
        return null;
      }
      return props.validator(String(valueRef.value));
    });
    return {
      __sfc: true,
      props: props,
      useMultipleOptions: useMultipleOptions,
      updateReportAnswer: updateReportAnswer,
      route: route,
      attrs: attrs,
      reportKeyMap: reportKeyMap,
      onInput: onInput,
      expanded: expanded,
      valueRef: valueRef,
      validationResult: validationResult,
      renderTrustedMarkdown: renderTrustedMarkdown
    };
  }
});